import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Older voucher emails linked here — forward to the dedicated gift page.
export const Route = createFileRoute("/redeem")({
  validateSearch: z.object({ code: z.string().optional() }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/redeem-gift", search: { code: search.code }, statusCode: 301 });
  },
});
